import ChattelSelect from './ChattelSelect';

export default ChattelSelect;
